import { useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { ChordDictionary } from "../chords/ChordDictionary";
import { Metronome } from "../Metronome";
import { useApi, loadFailed } from "../../lib/api";

const SECTIONS = [["goals", "Goals"], ["warmup", "Warm-up"], ["main_activity", "Main activity"], ["practice", "Practice"], ["homework", "Homework"]];

export const PlanView = ({ plan }) => (
  <div className="space-y-4" data-testid="plan-view">
    <h3 className="text-xl font-bold">{plan.title}</h3>
    {SECTIONS.map(([k, label]) => plan[k] ? (
      <div key={k}><p className="mono-label text-yellow-300">{label}</p><p className="mt-1 whitespace-pre-wrap text-sm text-zinc-300">{plan[k]}</p></div>
    ) : null)}
  </div>
);

export const LessonTools = ({ planId }) => {
  const api = useApi();
  const [plan, setPlan] = useState(null);
  useEffect(() => { if (planId) api.get(`/lesson-plans/${planId}`).then((r) => setPlan(r.data)).catch(loadFailed("the lesson plan")); }, [api, planId]);
  return (
    <section className="panel p-4" data-testid="lesson-tools">
      <Tabs defaultValue={planId ? "plan" : "chords"}>
        <TabsList className="bg-black">
          <TabsTrigger value="plan" data-testid="lesson-tab-plan">Lesson plan</TabsTrigger>
          <TabsTrigger value="chords" data-testid="lesson-tab-chords">Chords</TabsTrigger>
          <TabsTrigger value="metronome" data-testid="lesson-tab-metronome">Metronome</TabsTrigger>
        </TabsList>
        <TabsContent value="plan" className="mt-4">
          {plan ? <PlanView plan={plan} /> : <p className="text-sm text-zinc-500" data-testid="lesson-no-plan">No lesson plan attached to this session.</p>}
        </TabsContent>
        <TabsContent value="chords" className="mt-4"><ChordDictionary compact /></TabsContent>
        <TabsContent value="metronome" className="mt-4 max-w-xl"><Metronome /></TabsContent>
      </Tabs>
    </section>
  );
};
